<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><b>CONTENTS</b></p>
<p class="toc1"><a href="#/introduction">Introduction</a></p>
<p class="toc"><a href="#/chapter01">B<span class="small">ESSEMER</span></a></p>
<p class="toc1"><a href="#/chapter01#c1h1">Bessemer’s Haunted Hall of History</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">B<span class="small">IRMINGHAM</span></span></p>
<p class="toc1"><span href="#/chapter02#c2h1" title="Link target outside of Sample">The Alabama Theatre</span></p>
<p class="toc1"><span href="#/chapter02#c2h2" title="Link target outside of Sample">Bass Cemetery</span></p>
<p class="toc1"><span href="#/chapter02#c2h3" title="Link target outside of Sample">Haints in the Homewood Public Library</span></p>
<p class="toc1"><span href="#/chapter02#c2h4" title="Link target outside of Sample">The Linn Henley Building</span></p>
<p class="toc1"><span href="#/chapter02#c2h5" title="Link target outside of Sample">The Tutwiler Hotel</span></p>
<p class="toc1"><span href="#/chapter02#c2h6" title="Link target outside of Sample">The Redmont Hotel</span></p>
<p class="toc1"><span href="#/chapter02#c2h7" title="Link target outside of Sample">The Spirits of Sloss Furnaces</span></p>
<p class="toc1"><span href="#/chapter02#c2h8" title="Link target outside of Sample">The Sword in the Tree at Arlington</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">C<span class="small">OLUMBIANA</span></span></p>
<p class="toc1"><span href="#/chapter03#c3h1" title="Link target outside of Sample">Columbiana’s Haunted Courthouse</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">J<span class="small">ASPER</span></span></p>
<p class="toc1"><span href="#/chapter04#c4h1" title="Link target outside of Sample">The Face on the Door</span></p>
<p class="toc1"><span href="#/chapter04#c4h2" title="Link target outside of Sample">Jasper’s Haunted Radio Station</span></p>
<p class="toc1"><span href="#/chapter04#c4h3" title="Link target outside of Sample">Walker College</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">M<span class="small">ONTEVALLO</span></span></p>
<p class="toc1"><span href="#/chapter05#c5h1" title="Link target outside of Sample">The University of Montevallo</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc1"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6d3ad626